import styled from 'styled-components';
export const HeroContainer = styled.section `
  background: linear-gradient(135deg, #f0f9ff 0%, #f8fafc 50%, #ffffff 100%);
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  min-height: 700px;
  width: 100%;
  padding: 40px 20px;
`;
export const HeroBgRich = styled.div `
  position: absolute;
  inset: 0;
  z-index: 1;
`;
export const HeroShape = styled.div `
  position: absolute;
  filter: blur(1px);

  ${(props) => {
    const shapeConfigs = {
        'shape-1': `
        width: 300px;
        height: 300px;
        top: 0%;
        right: 15%;
        background: radial-gradient(circle at 40% 30%, #fef08a 0%, transparent 55%);
      `,
        'shape-2': `
        width: 350px;
        height: 350px;
        bottom: 0%;
        left: 0%;
        background: radial-gradient(ellipse at 25% 65%, #a5b4fc 0%, transparent 60%);
      `,
        'shape-3': `
        width: 380px;
        height: 380px;
        top: 25%;
        left: 20%;
        background: radial-gradient(circle, rgba(253,224,71,0.7) 0%, transparent 60%);
      `,
        'shape-4': `
        width: 240px;
        height: 240px;
        bottom: 25%;
        left: 40%;
        background: radial-gradient(circle, rgba(99,102,241,0.6) 0%, transparent 65%);
      `,
        'shape-5': `
        width: 68px;
        height: 68px;
        top: 60%;
        right: 35%;
        background: radial-gradient(circle, #fde047 0%, transparent 70%);
      `,
        'shape-6': `
        width: 152px;
        height: 152px;
        top: 15%;
        left: 25%;
        background: radial-gradient(circle, #93c5fd 0%, transparent 70%);
      `,
        'shape-7': `
        width: 160px;
        height: 32px;
        top: 42%;
        left: 5%;
        background: linear-gradient(45deg, #fef08a, #facc15);
        border-radius: 24px;
      `,
        'shape-8': `
        width: 28px;
        height: 96px;
        bottom: 15%;
        right: 28%;
        background: linear-gradient(0deg, #a5b4fc, #6366f1);
        border-radius: 16px;
      `,
        'shape-9': `
        width: 24px;
        height: 24px;
        top: 75%;
        left: 65%;
        background: radial-gradient(circle, #facc15 0%, transparent);
        border-radius: 12px;
      `,
        'shape-10': `
        width: 350px;
        height: 350px;
        bottom: 0%;
        right: 0%;
        background: radial-gradient(ellipse at 75% 65%, #a5b4fc 0%, transparent 60%);
      `,
        'shape-11': `
        width: 280px;
        height: 280px;
        top: 0%;
        right: 0%;
        background: radial-gradient(circle at 80% 20%, #fef08a 0%, transparent 55%);
      `,
        'shape-12': `
        width: 200px;
        height: 120px;
        top: 50%;
        right: 20%;
        background: radial-gradient(ellipse at 50% 50%, rgba(139,92,246,0.5) 0%, transparent 70%);
        border-radius: 50%;
      `,
        'shape-13': `
        width: 60px;
        height: 60px;
        top: 40%;
        right: 15%;
        background: radial-gradient(ellipse at 30% 30%, #ec4899 0%, #f472b6 50%, transparent 75%);
        border-radius: 50% 50% 50% 50% / 60% 60% 40% 40%;
        transform: rotate(-45deg);
      `,
        'shape-14': `
        width: 80px;
        height: 80px;
        top: 20%;
        right: 25%;
        background: linear-gradient(135deg, #10b981 0%, #059669 100%);
        clip-path: polygon(50% 0%, 61% 35%, 98% 35%, 68% 57%, 79% 91%, 50% 70%, 21% 91%, 32% 57%, 2% 35%, 39% 35%);
      `,
    };
    return shapeConfigs[props.$shapeClass] || '';
}}
`;
export const GlassCard = styled.div `
  margin: 0 auto;
  width: 90%;
  max-width: 900px;
  padding: 3rem 2.5rem;
  background: rgba(255, 255, 255, 0.32);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(22px);
  border-radius: 32px;
  border: 1px solid rgb(255 255 255 / 0%);
  box-shadow: 0 32px 100px rgb(0 0 0 / 0%), 0 8px 32px rgba(0, 0, 0, 0.08),
    inset 0 1px 0 rgb(255 255 255 / 19%);
  position: relative;
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 2rem;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 1px;
    background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.95) 50%, transparent);
    border-radius: inherit;
  }

  @media (max-width: 768px) {
    flex-direction: column;
    padding: 2rem 1.5rem;
    width: 95%;
    gap: 1.5rem;
  }
`;
export const GlassDetails = styled.div `
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  flex: 1;

  @media (max-width: 768px) {
    order: 2;
    align-items: center;
  }
`;
export const HeroTitle = styled.h1 `
  font-size: clamp(2.75rem, 5vw, 3.75rem);
  font-weight: 800;
  color: #0f172a;
  margin-bottom: 0.875rem;
  letter-spacing: -0.025em;
`;
export const HeroSubtitle = styled.p `
  font-size: 1.1875rem;
  color: #374151;
  margin-bottom: 2.25rem;
  line-height: 1.55;
  font-weight: 450;

  strong {
    font-size: 1.5rem;
    font-weight: 600;
  }

  @media (max-width: 768px) {
    text-align: center;
  }
`;
export const CTAButtons = styled.div `
  display: flex;
  gap: 1.25rem;
  flex-wrap: wrap;

  @media (max-width: 640px) {
    flex-direction: column;
    width: 100%;
  }
`;
export const Button = styled.a `
  padding: 10px 24px;
  border-radius: 50px;
  text-decoration: none;
  font-weight: 600;
  transition: all 0.3s;
  border: none;
  cursor: pointer;
  display: inline-block;

  ${(props) => props.$variant === 'primary'
    ? `
    background: linear-gradient(-180deg, #FFD700 0%, #e5c61c 100%);
    color: #1a1a1a;

    &:hover {
      background: #FDB927;
      transform: translateY(-2px);
      box-shadow: 0 10px 20px rgba(253, 183, 39, 0.3);
    }
  `
    : `
    background: linear-gradient(-180deg, #535353 0%, #000000 100%);
    color: #fff;

    &:hover {
      transform: translateY(-2px);
      background: #F3F4F6;
      color: #1a1a1a;
    }
  `}

  @media (max-width: 768px) {
    text-align: center;
  }
`;
export const PieChart = styled.div `
  width: 168px;
  height: 168px;
  position: relative;
  border-radius: 50%;
  flex-shrink: 0;
  overflow: hidden;

  img {
    width: 210px;
    height: 210px;
    object-fit: cover;
    transform: translate(-28px, -1px);
  }

`;
